import Vue from 'vue'
import Vuex from 'vuex'

import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'


Vue.use(Vuex);

var defaultCompanyCustomer = () => {
    return {
        id: '',
        fullname: '',
        email: '',
        mobile: '',
        tax_office: '',
        business_type: '',
        title: '',
        vat_number: ''
    }
}

var defaultAddressData = () => {
  return {
    address: '',
    country_code: '',
    city: '',
    area: '',
    state_code: '',
    postal_code: '',
    details: null,
  }
}

const initialState = {
    shopInfo: null,
    authUser: null,
    checkoutInfo: {
      fullname: '',
      email   : '',
      mobile  : '',
      vat_number: '',
      sameAddress: true,
      shipping_method_id: '',
      payment_method_id : '',
      request_invoice: '0',
      billingAddress: defaultAddressData(),
      shippingAddress: defaultAddressData(),
      companyCustomer: defaultCompanyCustomer(),
    },
    cart: {
        app_version: window.appVersion,
        expires_at: 'test',
        items: [],
        coupons: [],
        offers: [],
    },
    alias: window.company_alias
}

export default new Vuex.Store({
      state: initialState,

      getters: getters,

      actions: actions,

      mutations: mutations
})
